import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { NumericInputWithSlider } from '../NumericInputWithSlider';
import { visualConfig } from '../../config/visualConfig';

interface CartonInputsTabProps {
  cartonLength: number;
  cartonWidth: number;
  cartonHeight: number;
  cartonWeight: number;
  cartonQuantity: number;
  unitSystem: 'metric' | 'imperial';
  setCartonLengthAndReset: (value: number) => void;
  setCartonWidthAndReset: (value: number) => void;
  setCartonHeightAndReset: (value: number) => void;
  setCartonWeightAndReset: (value: number) => void;
  setCartonQuantityAndReset: (value: number) => void;
  goToNextTab: () => void;
}

export function CartonInputsTab({
  cartonLength,
  cartonWidth,
  cartonHeight,
  cartonWeight,
  cartonQuantity,
  unitSystem,
  setCartonLengthAndReset,
  setCartonWidthAndReset,
  setCartonHeightAndReset,
  setCartonWeightAndReset,
  setCartonQuantityAndReset,
  goToNextTab
}: CartonInputsTabProps) {
  const colors = visualConfig.colors.carton;
  
  return (
    <Card className={`${visualConfig.layout.card.minHeight} flex flex-col ${visualConfig.layout.card.background} ${visualConfig.layout.card.shape} overflow-hidden`}>
      <CardHeader className={`bg-gradient-to-r ${colors.gradient} text-white ${visualConfig.layout.header.padding}`}>
        <CardTitle className={visualConfig.layout.header.title}>Carton Dimensions & Quantity</CardTitle>
        <CardDescription className={`text-blue-100 ${visualConfig.layout.header.description}`}>
          Enter the dimensions, weight, and quantity of your cartons.
        </CardDescription>
      </CardHeader>
      <CardContent className={`${visualConfig.layout.content.spacing} ${visualConfig.layout.content.padding}`}>
        <NumericInputWithSlider
          id="carton-length"
          baseLabel="Length"
          value={cartonLength}
          onChange={setCartonLengthAndReset}
          min={1}
          max={100}
          step={unitSystem === 'metric' ? 1 : 0.1}
          unitSystem={unitSystem}
          unitType="dimension"
        />
        <NumericInputWithSlider
          id="carton-width"
          baseLabel="Width"
          value={cartonWidth}
          onChange={setCartonWidthAndReset}
          min={1}
          max={100}
          step={unitSystem === 'metric' ? 1 : 0.1}
          unitSystem={unitSystem}
          unitType="dimension"
        />
        <NumericInputWithSlider
          id="carton-height"
          baseLabel="Height"
          value={cartonHeight}
          onChange={setCartonHeightAndReset}
          min={1}
          max={100}
          step={unitSystem === 'metric' ? 1 : 0.1}
          unitSystem={unitSystem}
          unitType="dimension"
        />
        <NumericInputWithSlider
          id="carton-weight"
          baseLabel="Weight"
          value={cartonWeight}
          onChange={setCartonWeightAndReset}
          min={0.1}
          max={50}
          step={unitSystem === 'metric' ? 0.1 : 0.01}
          unitSystem={unitSystem}
          unitType="weight"
        />
        <NumericInputWithSlider
          id="carton-quantity"
          baseLabel="Quantity"
          value={cartonQuantity}
          onChange={setCartonQuantityAndReset}
          min={1}
          max={10000}
          step={1}
          unitSystem={unitSystem}
          unitType="quantity"
        />
      </CardContent>
      <div className={visualConfig.layout.footer.layout + ' ' + visualConfig.layout.footer.padding}>
        <div></div>
        <button
          onClick={goToNextTab}
          className={`${visualConfig.interactive.button.base} ${colors.button} ${visualConfig.interactive.button.focus} ${colors.ring}`}
        >
          Next
        </button>
      </div>
    </Card>
  );
} 